/**
 * MessageTemplateEditPage コンポーネント
 *
 * メッセージテンプレート編集ページのメインコンポーネント。
 * URL パスからテンプレート ID を取得し、対応するデータを読み込んでフォームを表示します。
 *
 * @file メッセージテンプレート編集ページ
 * @date 2025/06/26
 */

import React from 'react';
import { AppHeader } from 'src/components/ui';
import { MessageTemplateEditForm } from './messageTemplate.edit';
import { useLocation } from 'react-router-dom';
import { FullscreenLoading } from 'src/components/function/loading';
import { getMessageTemplateId } from 'src/root/path.function';
import { useMessageTemplateFormItem } from 'src/usecases/messageTemplate/reader';

export const MessageTemplateEditPage: React.FC = () => {
  // 現在のページの URL 情報を取得
  const location = useLocation();

  // メッセージテンプレートのデータを取得するための状態管理
  const _state = useMessageTemplateFormItem({
    mtId: getMessageTemplateId(location.pathname),
  });

  return (
    <FullscreenLoading isLoading={_state.data?.messageTemplate === undefined}>
      <AppHeader
        extraHeaderNames={[{ title: '編集' }]}
      >
        {_state.data?.messageTemplate === undefined ? (
          <></>
        ) : (
          <MessageTemplateEditForm formValue={_state.data.messageTemplate} />
        )}
      </AppHeader>
    </FullscreenLoading>
  );
};
